module.exports = [
    {"name": "AT",      "selector": ".country_at",          "offset": 10 },
    {"name": "SLOV",    "selector": ".country_slovenia",    "offset": 370 },
    {"name": "CRO",     "selector": ".country_croatia",     "offset": 480 },
    {"name": "BIH",     "selector": ".country_bih",         "offset": 1290 },
    {"name": "MNG",     "selector": ".country_montenegro",  "offset": 1480 },
    {"name": "ALB",     "selector": ".country_albania",     "offset": 1684 },
    {"name": "GR",      "selector": ".country_greece",      "offset": 2460 },
    {"name": "TR",      "selector": ".country_turkey",      "offset": 3870 },
    {"name": "IR",      "selector": ".country_iran",        "offset": 8514 },
    {"name": "PAK",     "selector": ".country_pakistan",    "offset": 13882 },
    {"name": "IN1",     "selector": ".country_india",       "offset": 17934 },
    {"name": "NEP",     "selector": ".country_nepal",       "offset": 18860 },
    {"name": "IN2",     "selector": ".country_india",       "offset": 20250 },
    {"name": "MY",      "selector": ".country_myanmar",     "offset": 21370 },
    {"name": "THA",     "selector": ".country_thailand",    "offset": 24353 },
    {"name": "MAL",     "selector": ".country_malaysia",    "offset": 28042 }
];



//////////////////
// WEBPACK FOOTER
// ./src/country_data.json
// module id = 19
// module chunks = 0